/* Chooses the right Table based on screen size */
import useWindowDimensions from "../../hooks/WindowSize";
import { useState } from "react";
import FullTable from "./FullTable";
import FlippedTable from "./FlippedTable";

export default function TranscoderTable(props) {
  const { height, width } = useWindowDimensions();
  // Sort by sessionSum || pendingSum + vestedSum + payoutSum , then lexicographic
  const [sorting, setSort] = useState("sessionSum");
  const [ascending, setAscending] = useState(false);
  const modSort = (newValue) => {
    if (sorting != newValue) {
      setSort(newValue);
    } else {
      setAscending(!ascending);
    }
  };
  let sortedTranscoders = [];
  for (const transcoder of props.transcoderInfo) {
    var inserted = false;
    // Insert the processed object based on selected sorting
    for (var idx = 0; idx < sortedTranscoders.length; idx++) {
      if (ascending) {
        if (sortedTranscoders[idx][sorting] > transcoder[sorting]) {
          sortedTranscoders.splice(idx, 0, transcoder);
          inserted = true;
          break;
        } else if (sortedTranscoders[idx][sorting] == transcoder[sorting]) {
          if (sortedTranscoders[idx].address > transcoder.address) {
            sortedTranscoders.splice(idx, 0, transcoder);
            inserted = true;
            break;
          }
        }
      } else {
        if (sortedTranscoders[idx][sorting] < transcoder[sorting]) {
          sortedTranscoders.splice(idx, 0, transcoder);
          inserted = true;
          break;
        } else if (sortedTranscoders[idx][sorting] == transcoder[sorting]) {
          if (sortedTranscoders[idx].address < transcoder.address) {
            sortedTranscoders.splice(idx, 0, transcoder);
            inserted = true;
            break;
          }
        }
      }
    }
    // Make sure we push it at the end of the list if this T has the lowest total payout
    if (inserted) {
      continue;
    }
    sortedTranscoders.push(transcoder);
  }
  if (width > 800) {
    return (
      <FullTable
        cachedENS={props.cachedENS}
        transcoderInfo={sortedTranscoders}
        selectTranscoder={props.selectTranscoder}
        selectedAddress={props.selectedAddress}
        setSort={modSort}
        sorting={sorting}
        ascending={ascending}
        poolInfo={props.poolInfo}
      />
    );
  } else {
    return (
      <FlippedTable
        cachedENS={props.cachedENS}
        transcoderInfo={sortedTranscoders}
        selectTranscoder={props.selectTranscoder}
        selectedAddress={props.selectedAddress}
        setSort={modSort}
        sorting={sorting}
        ascending={ascending}
        poolInfo={props.poolInfo}
      />
    );
  }
}
